import * as yup from 'yup';

export const validationSchema = yup.object({
    surname: yup
        .string()
        .required('Заполните поле')
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(40, 'Должно быть не более 40 символов.'),
    name: yup
        .string()
        .required('Заполните поле')
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(40, 'Должно быть не более 40 символов.'),
    patronymic: yup
        .string()
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(40, 'Должно быть не более 40 символов.'),
    email: yup
        .string()
        .required('Заполните поле')
        .test('email', 'Неверный формат', (value: string | any) =>
            /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
                value
            )
        ),
    phone: yup
        .string()
        .required('Заполните поле')
        .test('email', 'Неверный формат', (value: string | any) =>
            /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/.test(
                value
            )
        ),
    inn: yup
        .string()
        .min(10, 'Поле должно содержать не менее 10 символов')
        .max(12, 'Должно быть не более 12 символов.'),
    company: yup
        .string()
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(200, 'Должно быть не более 200 символов.'),
    title: yup
        .string()
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(200, 'Должно быть не более 200 символов.'),
    subject: yup
        .string()
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(200, 'Должно быть не более 200 символов.'),
});
